import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {StyledChartLegendContainer, StyledLegendDot} from './style'
import {formatNumber} from '@/utilities/helpers'

export interface PieChartLegendData {
    name: string
    value?: number
    color: string
}

interface PieChartLegendProps {
    data: PieChartLegendData[]
    size?: 'sm' | 'md'
}

export const PieChartLegend = ({data, size = 'md'}: PieChartLegendProps) => {
    return (
        <Flexbox direction="column" gap={3}>
            {data.map((item, index) => (
                <StyledChartLegendContainer key={index}>
                    <Flexbox gap={2} align="center">
                        <StyledLegendDot $color={item.color} />
                        {item.value && (
                            <Text
                                palette="neutral"
                                shade="900"
                                size={size === 'sm' ? 'textSm' : 'displaySm'}
                                weight={700}
                            >
                                {formatNumber(item.value)}
                            </Text>
                        )}
                        <Text palette="neutral" shade="600" size={size === 'sm' ? 'textSm' : 'textMd'} weight={400}>
                            {item.name}
                        </Text>
                    </Flexbox>
                </StyledChartLegendContainer>
            ))}
        </Flexbox>
    )
}
